<div class="tab-pane" role="tabpanel" id="disposicion">
    <fieldset id="agregar_disposicion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Tipo de proyecto</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy1" name="tipo_proy1" formControlName="tipo_proy1" (change)="add_tipo_proyecto()" value="SI">Condominio Tipo A</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy2" name="tipo_proy2" formControlName="tipo_proy2" (change)="add_tipo_proyecto()" value="SI">Condominio Tipo B</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy3" name="tipo_proy3" formControlName="tipo_proy3" (change)="add_tipo_proyecto()" value="SI">Edificaciones en loteo con construcci&oacute;n simult&aacute;nea</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy4" name="tipo_proy4" formControlName="tipo_proy4" (change)="add_tipo_proyecto()" value="SI">Urbanizaci&oacute;n Recibida</mat-checkbox>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy5" name="tipo_proy5" formControlName="tipo_proy5" (change)="add_tipo_proyecto()" value="SI">Urbanizacio&oacute;n Garantizada</mat-checkbox>
                                </div>
                                <div class="col-md-6">
                                    <mat-checkbox id="tipo_proy6" name="tipo_proy6" formControlName="tipo_proy6" (change)="add_tipo_proyecto()" value="SI">Recepcion de Urbanizaci&oacute;n solicitada conjuntamente</mat-checkbox>
                                </div>
                            </div>
                            <hr />

                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-3" style="padding-top: 20px">
                                    <strong>Permiso para el que se solicita esta recepci&oacute;n:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Permiso" id="perm_recep" name="perm_recep" formControlName="perm_recep" (change)="add_tipo_proyecto()" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2" style="padding-top: 20px">
                                    <strong>N&uacute;mero:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Número" id="perm_numero" name="perm_numero" formControlName="perm_numero" (change)="add_tipo_proyecto()" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left" style="padding-top: 15px">
                                <div class="col-md-3" style="padding-top: 20px">
                                    <strong>Fecha:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp2" id="perm_fecha" name="perm_fecha" formControlName="perm_fecha" [max]="maxDate" (dateinput)="add_tipo_proyecto($event, 'input')" (dateChange)="add_tipo_proyecto($event, 'input')">
                                        <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                                        <mat-datepicker #dp2 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2" style="padding-top: 20px">
                                    <strong>Superficie m2</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie" id="perm_sup" name="perm_sup" formControlName="perm_sup" (change)="add_tipo_proyecto()" />
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br>
                            <hr />
                            <div class="form-group" align="left" style="padding-top: 20px">
                                <div class="col-md-3">
                                    <strong>Modificaci&oacute;n de proyecto. Resoluci&oacute;n Nº:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Modificación" id="mod_proy_res" name="mod_proy_res" formControlName="mod_proy_res" (change)="add_tipo_proyecto()" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2" style="padding-top: 20px">
                                    <strong>Fecha:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" id="mod_proy_fech" name="mod_proy_fech" formControlName="mod_proy_fech" [max]="maxDate" (dateinput)="add_tipo_proyecto($event, 'input')" (dateChange)="add_tipo_proyecto($event, 'input')">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                            <br>

                            <hr />
                            <div class="form-group" align="left" style="padding-top: 20px; padding-bottom: 30px">
                                <div class="col-md-3">
                                    <strong>Recepci&oacute;n parcial:</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-radio-group formControlName="rparcial_proy_res" (change)="add_tipo_proyecto()">
                                        <mat-radio-button style="padding-right: 20px" name="rparcial_proy_res" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="rparcial_proy_res" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-3" style="padding-top: 20px">
                                    <strong>Destino</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Destino" id="dest_proy_res" name="dest_proy_res" formControlName="dest_proy_res" (change)="add_tipo_proyecto()" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2" style="padding-top: 20px">
                                    <strong>Superficie</strong>
                                </div>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Superficie" id="sup_proy_res" name="sup_proy_res" formControlName="sup_proy_res" (change)="add_tipo_proyecto()" />
                                        <span matSuffix>m²</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>